import { BLOCK_MAX_CHARACTERS_LENGTH } from "../constants/constants";
import { Node, Transforms, Element as SlateElement } from "slate";
import { getCharactersCount } from "./SlateUtils/index.js";
import { isNonverbalAtValidEdge } from "./SlateUtils/NonverbalUtils";

export const withInlines = (editor) => {
	const { insertData, insertText, isInline, isVoid } = editor;

	editor.isInline = (element) =>
		["pause", "nonverbal", "custom"].includes(element.type) || isInline(element);

	editor.isVoid = (element) => {
		return ["pause", "nonverbal"].includes(element.type) ? true : isVoid(element);
	};

	editor.insertText = (text) => {
		insertText(text);
	};

	editor.insertData = (data) => {
		insertData(data);
	};

	return editor;
};

// Safety net for the "chips only at block edges" rule. Per-keystroke guards keep the
// caret contained, but paste/drag can drop a chip mid-text — this relocates any such
// stranded chip back to the block's leading edge (or removes it if that fails).
export const withNonverbal = (editor) => {
	const { normalizeNode } = editor;

	editor.normalizeNode = (entry) => {
		const [node, path] = entry;

		if (
			SlateElement.isElement(node) &&
			node.type === "nonverbal" &&
			path.length === 3 &&
			!isNonverbalAtValidEdge(editor, path)
		) {
			try {
				Transforms.moveNodes(editor, { at: path, to: [path[0], 0, 0] });
			} catch (e) {
				try {
					Transforms.removeNodes(editor, { at: path });
				} catch (e2) {
					// give up rather than crash the editor
				}
			}
			return;
		}

		normalizeNode(entry);
	};

	return editor;
};

// Splits text into chunks at sentence boundaries, never exceeding maxLength per chunk.
// Falls back to word boundaries when a single sentence exceeds the limit.
export function splitTextIntoChunks(text, maxLength) {
	if (!text || text.length <= maxLength) return [text];

	// Split keeping the sentence-ending delimiter attached to the preceding sentence
	const parts = text.split(/(\.\s+|!\s+|\?\s+)/);
	const sentences = [];
	for (let i = 0; i < parts.length; i += 2) {
		const combined = parts[i] + (parts[i + 1] || '');
		if (combined) sentences.push(combined);
	}

	const chunks = [];
	let current = '';

	for (const sentence of sentences) {
		if (sentence.length > maxLength) {
			if (current) { chunks.push(current); current = ''; }
			let remaining = sentence;
			while (remaining.length > maxLength) {
				const splitAt = remaining.lastIndexOf(' ', maxLength);
				if (splitAt <= 0) {
					chunks.push(remaining.substring(0, maxLength));
					remaining = remaining.substring(maxLength);
				} else {
					chunks.push(remaining.substring(0, splitAt));
					remaining = remaining.substring(splitAt + 1);
				}
			}
			if (remaining) current = remaining;
		} else if (current.length + sentence.length <= maxLength) {
			current += sentence;
		} else {
			chunks.push(current);
			current = sentence;
		}
	}

	if (current) chunks.push(current);
	return chunks;
}

export const withBlockLevelCharactersLimit = (editor) => {
	const { insertText } = editor;

    editor.insertText = (text) => {

		try {
			const blockIndex = editor.selection.anchor.path[0];
			const block = Node.get(editor, [blockIndex]);
			const charactersCount = getCharactersCount(block.children);
			const remainingCharactersCount = BLOCK_MAX_CHARACTERS_LENGTH - charactersCount;

			if (getCharactersCount(block.children) + text.length >= BLOCK_MAX_CHARACTERS_LENGTH) {
				console.log("Can't add more text");
			}

			insertText(text.substring(0, remainingCharactersCount));
		} catch (e) {
			insertText(text);
		}

    };
    return editor;
} 